import Navigator from '../../../../components/common/Navigator'
import AcademicCreate from './Create'

export default function IndustryAcademyCollaborationForm() {
  return (
    <div className="lg:py-6 p-4 lg:w-11/12 lg:mx-auto   ">
      <div className="mb-6 border-b border-primaryBlue pb-4">
        <Navigator
          title="Industry Academy Collaboration Form"
          slug="INTERNSHIPFORM"
        />
        <h1 className="text-3xl font-semibold text-gray-900">
          Industry Academy Collaboration
        </h1>
        <p className="text-md text-LightGray mt-1">
          Application for KIED’S Industry-Academia Collaboration Initiatives
        </p>
      </div>
      <AcademicCreate />
    </div>
  )
}
